import React from 'react';
import { Text, Pressable, View } from 'react-native';
import PropTypes from 'prop-types';
import { LineIndicator, Checkbox, Icon } from 'LocalGluons';
import Theme from 'Theme';
import { t } from 'Locale';
import {
    getItemSubtitle,
    getAssetTitle,
    getAssetImageUrl,
    getImageKeyByItemType,
    ITEM_TYPES
} from 'Utils';
import { useStore } from 'Store';
import { CachedImage } from 'LocalGluons/components/CachedImage';
import styles from './DownloadItem.jss';

const iconStyle = {
    alignSelf: 'center',
    marginRight: Theme.primaryMargin
};

const DownloadItem = ({
    onPress,
    progressText,
    isEditing,
    isSelected,
    isFirst,
    onCheckbox,
    progress,
    isPaused,
    togglePause,
    deleteItem,
    item
}) => {
    const isDone = progress >= 100;

    const { deviceStorageState } = useStore();

    return (
        <View style={styles.row}>
            <Pressable style={styles.container} onPress={onPress}>
                {item.modelType === ITEM_TYPES.TV ? (
                    <CachedImage
                        source={{
                            uri:
                                item.data?.channelLogoUrl ||
                                item.metadata?.metaData?.detail?.channelLogo
                        }}
                        style={[styles.icon, isEditing && styles.hiddenIconStyle]}
                    />
                ) : (
                    <CachedImage
                        source={{ uri: getAssetImageUrl(item, getImageKeyByItemType(item), 'LOW') }}
                        style={[styles.poster]}
                    />
                )}
                <View style={[styles.textArea, isFirst && styles.firstTextArea]}>
                    <View style={styles.metadata}>
                        <Text numberOfLines={1} style={styles.programTitle}>
                            {getAssetTitle(item, deviceStorageState.language) || ''}
                        </Text>
                        <View style={{ flexDirection: 'row' }}>
                            {isPaused ? (
                                <Text style={styles.programSubtitle}>{t('DOWNLOAD.PAUSED')}</Text>
                            ) : (
                                <>
                                    <Text style={styles.progressText}>{progressText}</Text>
                                    <Text style={styles.programSubtitle}>
                                        {getItemSubtitle(item, deviceStorageState.language)}
                                    </Text>
                                </>
                            )}
                        </View>
                    </View>
                    {!isDone &&
                        !isEditing &&
                        (isPaused ? (
                            <>
                                <Icon style={iconStyle} name="close" onPress={deleteItem} />
                                <Icon style={iconStyle} name="download" onPress={togglePause} />
                            </>
                        ) : (
                            <Icon style={iconStyle} name="player_pause" onPress={togglePause} />
                        ))}
                    {isEditing && (
                        <Checkbox
                            key={isSelected ? 'selected' : 'empty'}
                            style={styles.checkbox}
                            checked={isSelected}
                            onPress={onCheckbox}
                            hitSlop={{ top: 8, left: 8, right: 8, bottom: 8 }}
                        />
                    )}
                </View>
            </Pressable>
            <View style={isEditing ? styles.underline : styles.progressBar}>
                <LineIndicator progress={isDone ? 0 : progress} color={Theme.activeColor} />
            </View>
        </View>
    );
};

DownloadItem.defaultProps = {
    progressText: '',
    progress: 0,
    isEditing: false,
    isSelected: false,
    isPaused: false,
    isFirst: false,
    onPress: () => {},
    togglePause: () => {},
    onCheckbox: () => {},
    deleteItem: () => {}
};

DownloadItem.propTypes = {
    progressText: PropTypes.string,
    progress: PropTypes.number,
    isEditing: PropTypes.bool,
    isSelected: PropTypes.bool,
    isPaused: PropTypes.bool,
    isFirst: PropTypes.bool,
    onPress: PropTypes.func,
    togglePause: PropTypes.func,
    onCheckbox: PropTypes.func,
    deleteItem: PropTypes.func,
    item: PropTypes.shape({}).isRequired
};

export default DownloadItem;
